<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>代理</el-breadcrumb-item>
			<el-breadcrumb-item>录单</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="margin-t-20 flex justify-content-s-b">
			<el-form :inline="true" :model="queryForm" size="small">
				<el-form-item>
					<el-input v-model="queryForm.keyword" placeholder="请输入商品名称/客户信息"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryForm.status" placeholder="选择城市">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryForm.status" placeholder="支付方式">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryForm.status" placeholder="付款状态">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary">查询</el-button>
					<el-button type="infor">刷新</el-button>
				</el-form-item>
			</el-form>

			<div>
				<el-button @click="handleAdd" type="primary" size="small">+ 新增</el-button>
			</div>
		</div>

		<!-- 订单列表区域 -->
		<div style="width: 75vw;">
			<div style="border: 1px solid #B8B8B8;">
				<div class="order-item-header">
					<span class="margin-r-30">1</span>
					<span class="margin-r-30">订单号：1441XXXXXXXXXXXX</span>
					<span class="margin-r-30">下单时间：2021-11-19 11：50：50</span>
					<span class="margin-r-30">支付时间：2021-11-19 11：50：50</span>
					<span>预约时间：2021-11-19 11：50：50</span>
				</div>

				<div class="order-desc flex">
					<!-- 订单商品信息区域 -->
					<div class="order-desc-block flex-1 flex align-items-c">
						<img src="../../../assets/bg.jpg" class="commodity-img" alt="商品图片">

						<div class="flex-1 font-b" style="margin-left: 10px;">
							<span class="font-b">【全国预定】九价HPV宫颈癌疫苗代预约</span>
							<div class="flex justify-content-s-b font-b">
								<span>￥100.00</span><span>x1</span>
							</div>
							<div class="flex justify-content-s-b font-b">
								<span>实付金额</span><span>￥100.00</span>
							</div>
							<div class="flex justify-content-s-b font-b">
								<span>使用余额</span><span>￥100.00</span>
							</div>
						</div>
					</div>
					<!-- 订单商品信息区域 -->

					<!-- 订单状态信息 -->
					<div class="order-desc-block flex-1 flex flex-direction-c justify-content-c">
						<div class="flex font-b">
							<span>付款状态：</span><span class="blue">待付款</span>
						</div>
						<div class="flex font-b">
							<span>付款方式：</span><span class="blue">微信转账</span>
						</div>
						<div class="flex font-b">
							<span>付款条件：</span><span class="blue">暂无</span>
						</div>
						<div class="flex font-b">
							<span>商品渠道：</span><span>暂无</span>
						</div>
					</div>
					<!-- 订单状态信息 end -->

					<!-- 用户信息 -->
					<div class="order-desc-block flex-1">
						<div class="flex align-items-b font-b">
							<i class="el-icon-user blue margin-r-8"></i><span
								style="width: 80px;">客户昵称：</span><span>哈喽</span>
						</div>
						<div class="flex align-items-b font-b">
							<i class="el-icon-chat-dot-round blue margin-r-8"></i><span
								style="width: 80px;">联系方式：</span><span>0110</span>
						</div>
						<div class="flex align-items-b font-b">
							<i class="el-icon-user blue margin-r-8"></i><span
								style="width: 80px;">收件人：</span><span>舒克</span>
						</div>
						<div class="flex align-items-b font-b">
							<i class="el-icon-truck blue margin-r-8"></i><span
								style="width: 80px;">收货地址：</span><span>暂无</span>
						</div>
					</div>
					<!-- 用户信息 end -->

					<!-- 操作 -->
					<div style="width: 200px;" class="order-desc-block flex align-items-c">
						<el-button type="primary" size="small">编辑</el-button>
					</div>
					<!-- 操作 -->
				</div>
			</div>
		</div>
		<!-- 订单列表区域 end -->

		<!-- 分页 -->
		<div class="margin-t-10 flex">
			<el-pagination background layout="prev, pager, next, jumper" :total="total"
				:current-page.sync="queryForm.page" @current-change="handleCurrentPageChange">
			</el-pagination>
			<el-button size="small">确定</el-button>
		</div>
		<!-- 分页 end -->

		<!-- 编辑/新增订单的对话框 -->
		<el-dialog :title="title" :visible.sync="showOrderFormDialog" width="30%" :before-close="closeOrderFormDialog">
			<el-form :model="orderForm" :rules="rules" ref="orderForm" size="small" label-width="100px">
				<el-form-item label="商品分类" prop="region">
					<el-select v-model="orderForm.region" placeholder="请选择商品分类">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品名称" prop="name">
					<el-input v-model="orderForm.name"></el-input>
				</el-form-item>
				<el-form-item label="订单号" prop="name">
					<el-input v-model="orderForm.name"></el-input>
				</el-form-item>
				<el-form-item label="收件人昵称" prop="name">
					<el-input v-model="orderForm.name"></el-input>
				</el-form-item>
				<el-form-item label="收件人姓名" prop="name">
					<el-input v-model="orderForm.name"></el-input>
				</el-form-item>
				<el-form-item label="收件人电话" prop="name">
					<el-input v-model="orderForm.name"></el-input>
				</el-form-item>
				<el-form-item label="收货地址" prop="name">
					<el-input v-model="orderForm.name"></el-input>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="closeOrderFormDialog">取 消</el-button>
				<el-button type="primary" @click="handleSubmit">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 编辑/新增订单的对话框 end -->
	</div>
</template>

<script>
	export default {
		name: 'EnterOrder',
		data() {
			return {
				title: '',
				showOrderFormDialog: false,
				orderForm: {},
				rules: {},
				queryForm: {
					page: 1,
				},
				total: 0,
				tableData: []
			}
		},
		methods: {
			handleCurrentPageChange() {

			},
			handleAdd() {
				this.title = '新增'
				this.showOrderFormDialog = true
			},
			handleSubmit() {

			},

			closeOrderFormDialog() {
				this.showOrderFormDialog = false
			}
		}
	}
</script>

<style lang="less" scoped>
	.margin-r-30 {
		margin-right: 50px;
	}

	.margin-r-8 {
		margin-right: 8px;
	}

	.font-b {
		font-weight: bold;
	}

	.blue {
		color: #007CFF;
	}

	.order-desc-block:not(:last-child) {
		border-right: 1px solid #B8B8B8;
	}

	.order-desc-block {
		padding: 10px;
	}

	.commodity-img {
		width: 100px;
		height: 100px;
		object-fit: scale-down;
	}

	.order-desc {
		font-size: 14px;
		line-height: 1.6;
	}

	.order-item-header {
		padding: 17px 20px;
		background: #F5F5F5;
		font-size: 14px;
		border-bottom: 1px solid #B8B8B8;
	}
</style>
